
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexvuurGzKzTNMeta } from "/codebuild/output/src2481625406/src/pages/index.vue?macro=true";
import { default as aboutFM7fTMcBFbMeta } from "/codebuild/output/src2481625406/src/pages/about.vue?macro=true";
import { default as dataXEx9VRbazuMeta } from "/codebuild/output/src2481625406/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionfoTio8G8jCMeta } from "/codebuild/output/src2481625406/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioning9bgMOEucKeMeta } from "/codebuild/output/src2481625406/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyGWIK080NFiMeta } from "/codebuild/output/src2481625406/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accountid6kDLEinjMeta } from "/codebuild/output/src2481625406/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statueDq0KGpYddrMeta } from "/codebuild/output/src2481625406/src/pages/account-settings/statue.vue?macro=true";
import { default as supporttj2S0iv7LvMeta } from "/codebuild/output/src2481625406/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsXDfJgNPitNMeta } from "/codebuild/output/src2481625406/src/pages/account-settings.vue?macro=true";
import { default as activate_45account4Eq4pIbsoRMeta } from "/codebuild/output/src2481625406/src/pages/activate-account.vue?macro=true";
import { default as companyryNcpXwf5QMeta } from "/codebuild/output/src2481625406/src/pages/admin/company.vue?macro=true";
import { default as consents67nJk7CbURMeta } from "/codebuild/output/src2481625406/src/pages/admin/consents.vue?macro=true";
import { default as leads4Lq3AfkJmvMeta } from "/codebuild/output/src2481625406/src/pages/admin/leads.vue?macro=true";
import { default as paymentsk0bKI7IG5pMeta } from "/codebuild/output/src2481625406/src/pages/admin/payments.vue?macro=true";
import { default as premiumxNO8hAjJ3PMeta } from "/codebuild/output/src2481625406/src/pages/admin/premium.vue?macro=true";
import { default as profiles4aG0FBBF6rMeta } from "/codebuild/output/src2481625406/src/pages/admin/profiles.vue?macro=true";
import { default as usersc2AxcKZAgeMeta } from "/codebuild/output/src2481625406/src/pages/admin/users.vue?macro=true";
import { default as change_45password7PsIxHkTcMMeta } from "/codebuild/output/src2481625406/src/pages/change-password.vue?macro=true";
import { default as _91id_933uZmVvc0l5Meta } from "/codebuild/output/src2481625406/src/pages/chat/[id].vue?macro=true";
import { default as aiMozJRp4HW5Meta } from "/codebuild/output/src2481625406/src/pages/chat/ai.vue?macro=true";
import { default as indexGeER9Av9E8Meta } from "/codebuild/output/src2481625406/src/pages/chat/index.vue?macro=true";
import { default as chatFdGQ5QUDrgMeta } from "/codebuild/output/src2481625406/src/pages/chat.vue?macro=true";
import { default as _91id_93LPnvjGOgR5Meta } from "/codebuild/output/src2481625406/src/pages/client/profile/[id].vue?macro=true";
import { default as indexld6Y7DFL2QMeta } from "/codebuild/output/src2481625406/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93NAVbqZyRAbMeta } from "/codebuild/output/src2481625406/src/pages/contacts/[id].vue?macro=true";
import { default as indexweTk3NoWl8Meta } from "/codebuild/output/src2481625406/src/pages/contacts/index.vue?macro=true";
import { default as contactsCqXYLIjHlYMeta } from "/codebuild/output/src2481625406/src/pages/contacts.vue?macro=true";
import { default as _91userId_93iWuVpOLHKeMeta } from "/codebuild/output/src2481625406/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexoSJsYqNh8fMeta } from "/codebuild/output/src2481625406/src/pages/login/index.vue?macro=true";
import { default as register_45success8k6EC3VIIQMeta } from "/codebuild/output/src2481625406/src/pages/login/register-success.vue?macro=true";
import { default as loginoNcYa7d1pvMeta } from "/codebuild/output/src2481625406/src/pages/login.vue?macro=true";
import { default as logoutXG8kPRFFlVMeta } from "/codebuild/output/src2481625406/src/pages/logout.vue?macro=true";
import { default as consentsNNcW0KsqUOMeta } from "/codebuild/output/src2481625406/src/pages/manager/consents.vue?macro=true";
import { default as integrationsCP4BSd7ITGMeta } from "/codebuild/output/src2481625406/src/pages/manager/integrations.vue?macro=true";
import { default as leads4kCbiYRTqFMeta } from "/codebuild/output/src2481625406/src/pages/manager/leads.vue?macro=true";
import { default as paymentsqoJZoXJXcpMeta } from "/codebuild/output/src2481625406/src/pages/manager/payments.vue?macro=true";
import { default as profileorQjJUnOFuMeta } from "/codebuild/output/src2481625406/src/pages/manager/profile.vue?macro=true";
import { default as teamBDOOL8SwW0Meta } from "/codebuild/output/src2481625406/src/pages/manager/team.vue?macro=true";
import { default as indexrm9zwPgddzMeta } from "/codebuild/output/src2481625406/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientGGhUF0SCZPMeta } from "/codebuild/output/src2481625406/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src2481625406/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplaceYhQXcWVJIWMeta } from "/codebuild/output/src2481625406/src/pages/marketplace.vue?macro=true";
import { default as subscribeMCNqGyvuD8Meta } from "/codebuild/output/src2481625406/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46client8bhzuNcV1MMeta } from "/codebuild/output/src2481625406/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientmoUVHk1QjjMeta } from "/codebuild/output/src2481625406/src/pages/orders/my.client.vue?macro=true";
import { default as privacylQiFqs8c84Meta } from "/codebuild/output/src2481625406/src/pages/privacy.vue?macro=true";
import { default as indexTDelh3UNzNMeta } from "/codebuild/output/src2481625406/src/pages/recover/index.vue?macro=true";
import { default as successSklNnh5YA1Meta } from "/codebuild/output/src2481625406/src/pages/register/success.vue?macro=true";
import { default as _91id_934OYTITHlNqMeta } from "/codebuild/output/src2481625406/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexypdSaYGcAaMeta } from "/codebuild/output/src2481625406/src/pages/sales/profile/index.vue?macro=true";
import { default as statuexyK7UOlNCnMeta } from "/codebuild/output/src2481625406/src/pages/statue.vue?macro=true";
import { default as successpazXiF84LkMeta } from "/codebuild/output/src2481625406/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubd2O6FFpfxvMeta } from "/codebuild/output/src2481625406/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubd2O6FFpfxv } from "/codebuild/output/src2481625406/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexvuurGzKzTNMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutFM7fTMcBFbMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutFM7fTMcBFbMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsXDfJgNPitNMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsXDfJgNPitNMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src2481625406/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45account4Eq4pIbsoRMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45account4Eq4pIbsoRMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companyryNcpXwf5QMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companyryNcpXwf5QMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consents67nJk7CbURMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consents67nJk7CbURMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leads4Lq3AfkJmvMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leads4Lq3AfkJmvMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsk0bKI7IG5pMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsk0bKI7IG5pMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumxNO8hAjJ3PMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumxNO8hAjJ3PMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profiles4aG0FBBF6rMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profiles4aG0FBBF6rMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersc2AxcKZAgeMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersc2AxcKZAgeMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45password7PsIxHkTcMMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45password7PsIxHkTcMMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/change-password.vue")
  },
  {
    name: chatFdGQ5QUDrgMeta?.name,
    path: "/en/chat",
    meta: chatFdGQ5QUDrgMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_933uZmVvc0l5Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: aiMozJRp4HW5Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: indexGeER9Av9E8Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chatFdGQ5QUDrgMeta?.name,
    path: "/pl/chat",
    meta: chatFdGQ5QUDrgMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_933uZmVvc0l5Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: aiMozJRp4HW5Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: indexGeER9Av9E8Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93LPnvjGOgR5Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93LPnvjGOgR5Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexld6Y7DFL2QMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexld6Y7DFL2QMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/client/profile/index.vue")
  },
  {
    name: contactsCqXYLIjHlYMeta?.name,
    path: "/en/contacts",
    meta: contactsCqXYLIjHlYMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93NAVbqZyRAbMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexweTk3NoWl8Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsCqXYLIjHlYMeta?.name,
    path: "/pl/contacts",
    meta: contactsCqXYLIjHlYMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93NAVbqZyRAbMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexweTk3NoWl8Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93iWuVpOLHKeMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93iWuVpOLHKeMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexvuurGzKzTNMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexvuurGzKzTNMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/index.vue")
  },
  {
    name: loginoNcYa7d1pvMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src2481625406/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexoSJsYqNh8fMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45success8k6EC3VIIQMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: loginoNcYa7d1pvMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src2481625406/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexoSJsYqNh8fMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45success8k6EC3VIIQMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutXG8kPRFFlVMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutXG8kPRFFlVMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsNNcW0KsqUOMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsNNcW0KsqUOMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsCP4BSd7ITGMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsCP4BSd7ITGMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leads4kCbiYRTqFMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leads4kCbiYRTqFMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsqoJZoXJXcpMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsqoJZoXJXcpMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileorQjJUnOFuMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileorQjJUnOFuMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamBDOOL8SwW0Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamBDOOL8SwW0Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/manager/team.vue")
  },
  {
    name: marketplaceYhQXcWVJIWMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceYhQXcWVJIWMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src2481625406/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientGGhUF0SCZPMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2481625406/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceYhQXcWVJIWMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceYhQXcWVJIWMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src2481625406/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientGGhUF0SCZPMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2481625406/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribeMCNqGyvuD8Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribeMCNqGyvuD8Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46client8bhzuNcV1MMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2481625406/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46client8bhzuNcV1MMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2481625406/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientmoUVHk1QjjMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2481625406/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientmoUVHk1QjjMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2481625406/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacylQiFqs8c84Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacylQiFqs8c84Meta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexTDelh3UNzNMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexTDelh3UNzNMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src2481625406/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src2481625406/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_934OYTITHlNqMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_934OYTITHlNqMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexypdSaYGcAaMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexypdSaYGcAaMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statuexyK7UOlNCnMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statuexyK7UOlNCnMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successpazXiF84LkMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successpazXiF84LkMeta || {},
    component: () => import("/codebuild/output/src2481625406/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubd2O6FFpfxvMeta?.name,
    path: "/old-page",
    component: component_45stubd2O6FFpfxv
  }
]